import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/balance`, { params: params });
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/balance/${id}`);
	},
	transactions(id, params) {
		return Repository.get(`/company/${company.value.id}/admin/balance/${id}/transactions`, { params: params });
	},
	payment(id, payload) {
		return Repository.post(`/company/${company.value.id}/admin/balance/${id}/payment`, payload).then((response) => {
			toast.success(`Pago registrado correctamente.`);
			return response;
		});
	}
}